import { Img } from "components";
import Wrapper from "../components/Wrapper";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Modal from "react-modal";
import LoadingModal from "components/LoadingModal";
import SocialMediaPost from "./SocialMediaPost";
import buildPayloads from "./buildPayloads";

const videoLinks = [{ url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/demo-social-hub.mp4" }];

const LIST = [
  {
    title: "Science Fair",
    image: "images/soomuch-demo/ScienceFair.svg",
    imageClasses: "",
  },
  {
    title: "Sports Day",
    image: "images/soomuch-demo/SportsDay.svg",
    imageClasses: "",
  },
  {
    title: "Annual Day",
    image: "images/soomuch-demo/AnnualDay.svg",
    imageClasses: "",
  },
];

const loadingMessages = [
  "Selecting the perfect words for your event...",
  "Analysing past engagement trends...",
  "Crafting visually appealing descriptions...",
  "Optimizing hashtags for maximum reach...",
];
export const EVENT_OPTIONS = [
  "Social Hub Intro",
  "Science Fair",
  "Sports Day",
  "Annual Day",
];

export const MAX_RETRY_LIMIT = 25;

const platformNames = {
  facebookPost: "Facebook",
  facebookReel: "Facebook Reels",
  instagramPost: "Instagram",
  instagramReel: "Instagram Reels",
  youtubePost: "YouTube",
};

const axiosHeaders = {
  database: "stark_edu",
  "user-name": "9999999999",
  source: "STAFF",
  "user-role": "STAFF",
  "user-id": "154148",
  "institute-id": "670",
  "academic-year-id": "1",
  "branch-id": "1",
};

const customStyles = {
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    padding: "0",
    margin: "0",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

const SocialHubBoostEngagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [shareStatusMessage, setShareStatusMessage] = useState("");
  const [shareResults, setShareResults] = useState(null);
  const [isSharing, setIsSharing] = useState(false);
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);
    const [successModal, setSuccessModal] = useState<any>(false);

  const retryCount =
    Number.parseInt(sessionStorage.getItem("socialMediaPostRetryCount"), 10) ||
    0;

  const handlePreview = async (eventSelection) => {
    const currentSelection = eventSelection || selected;

    if (!currentSelection) {
      return;
    } else {
      try {
        setIsLoading(true);
        const response = await axios.post(
          `https://stg.soomuch.ai/api/v1/master/textGenerate`,
          {
            category: "hashtags",
            kwargs: {
              topic:
                currentSelection === "Social Hub Intro"
                  ? "School Introduction Video "
                  : currentSelection,
            },
          }
        );
        setData(response?.data?.data);
      } catch (err) {
          setSuccessModal(successModal => ({ key: "error", message: (err?.message || "An error occurred") }));
        // Swal.fire({
        //   icon: "error",
        //   title: err?.message || "An error occurred",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleRetry = () => {
    handlePreview(selected);
  };

  const shareToAllPlatforms = async () => {
    setIsModalOpen(false);
    setIsResultModalOpen(true);
    setIsSharing(true);
    setShareResults(null);
    setShareStatusMessage("Starting to share...");

    // const ip = await getIPAddress();
    const payloads = buildPayloads(data, selected);
    const responseResults = {};

    const platformsToShare =
      selected === "Social Hub Intro"
        ? ["facebookReel", "instagramReel"]
        : Object.keys(payloads);

    for (const key of platformsToShare) {
      const { url, payload } = payloads[key];
      const platform = platformNames[key] || key;
      console.log("keuy", key);
      setShareStatusMessage(`Sharing on ${platform}...`);

      try {
        const response = await axios.post(url, payload, {
          headers: {
            ...axiosHeaders,
            ...(key === "facebookPost" ? { "IP-ADDRESS": "ip" } : {}),
          },
        });
        if (!!response?.data?.data?.url) {
          window.open(response?.data?.data?.url, "_blank");
        }
        responseResults[key] = {
          success: !!response?.data?.data?.url,
          data: response.data,
        };
      } catch (error) {
        responseResults[key] = {
          success: false,
          error: error.response?.data || error.message,
        };
      }
    }

    setShareStatusMessage("All platforms shared.");
    setShareResults(responseResults);
    setIsSharing(false);
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Social Media Post"
        style={customStyles}
      >
        <div className="">
          {isLoading ? (
            <div className="w-[400px] h-[400px]">
              <LoadingModal
                isOpen={isLoading}
                loadingTexts={loadingMessages}
                intervalTime={1800}
              />
              Loading
            </div>
          ) : (
            <SocialMediaPost
              data={data}
              setIsModalOpen={setIsModalOpen}
              handleRetry={handleRetry}
              onPostNowClick={shareToAllPlatforms}
              selectedEvent={selected}
            />
          )}
        </div>
      </Modal>

      {/* While sharing on social media */}
      <Modal
        isOpen={isResultModalOpen}
        onRequestClose={() => setIsResultModalOpen(false)}
        contentLabel="Social Media  Post Sharing"
        style={customStyles}
      >
        <div className="w-[380px] min-h-[80px] p-4 bg-gray-50 rounded-xl shadow-lg">
          {!!shareStatusMessage && (
            <p className="mb-4 text-sm italic text-center">
              {shareStatusMessage || "Sharing on Social Media"}
            </p>
          )}

          {shareResults && (
            <div className="mb-6">
              <h2 className="font-manropeSB text-xl mb-4 text-center">
                Share Results
              </h2>
              <ul className="space-y-3">
                {Object.entries(shareResults).map(([key, result]: any) => (
                  <li
                    key={key}
                    className="flex items-center justify-between bg-white px-4 py-2 rounded-lg border border-gray-200 shadow-sm"
                  >
                    <span className="text-gray-700 font-medium">
                      {platformNames[key] || key}
                    </span>
                    <span
                      className={`px-2 py-1 text-xs font-manropeSB rounded-full ${
                        result.success
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {result.success ? "Success" : "Failed"}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <button
            onClick={() => setIsResultModalOpen(false)}
            disabled={isSharing}
            className="block w-full bg-smd_blue-normal hover:bg-[#0e305a] text-[#fff] font-manropeSB py-2 rounded-lg transition duration-150 ease-in-out"
          >
            Back
          </button>
        </div>
      </Modal>
      <Wrapper
        title={"Social Hub"}
        description={
          <>
            <span className="font-manropeB">Boost engagement</span> by
            integrating social media, AI-powered updates, and direct
            communication <br /> via our{" "}
            <span className="font-manropeB">school app</span> and{" "}
            <span className="font-manropeB"> WhatsApp</span>—keeping parents
            connected 24/7.
          </>
        }
        videoLinks={videoLinks}
        body={
          <>
            <div className="flex flex-col items-between justify-center text-center">
              <div className="grid grid-cols-3 gap-[2vh]">
                <div className="col-span-3">
                  <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal mt-2">
                    Select event, we’ll show how magic works
                  </h2>
                </div>
                {LIST?.map((item, index) => (
                  <div
                    key={"asjdbnadbnasdasd" + index}
                    className="py-[1.6vh] flex flex-col justify-center gap-y-3 text-[2.4vh] bg-smd_white-light border-2 border-[#FBF1E7] rounded-3xl shadow-sm w-full backdrop-blur-sm"
                  >
                    <p className="font-manropeSB">{item?.title}</p>
                    <Img
                      src={item?.image}
                      className={
                        !!item?.imageClasses
                          ? item?.imageClasses
                          : "bg-[#D9D9D9] mx-auto w-[85%] min-h-[30vh] rounded-xl"
                      }
                    />
                    <button
                      className={`mx-auto w-[85%] font-inter text-[2.5vh] font-light bg-smd_blue-normal text-gray-100 p-3 rounded-xl hover:bg-smd_blue-dark transition-colors duration-300`}
                      onClick={() => {
                        const newSelection = item?.title;
                        setSelected(newSelection);
                        if (retryCount < MAX_RETRY_LIMIT) {
                          sessionStorage.setItem(
                            "socialMediaPostRetryCount",
                            String(retryCount + 1)
                          );
                          setIsModalOpen(true);
                          handlePreview(newSelection); // Pass the new selection directly
                        } else {
                          Swal.fire({
                            icon: "error",
                            title:
                              "Retry limit reached. Please try again later.",
                            showConfirmButton: false,
                            timer: 3000,
                          });
                        }
                      }}
                    >
                      Preview
                    </button>
                  </div>
                ))}
                <div className="col-span-3">
                  <p className={`text-[2vh] text-center font-medium`}>
                    <span className="font-manropeB">Note:</span> For demo
                    purpose, we are currently displaying this process manually.
                    However, under normal <br /> circumstances, this action
                    occurs automatically without any required intervention.
                  </p>
                </div>
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

export default SocialHubBoostEngagement;
